import Placeholder from "@tiptap/extension-placeholder";
import { StarterKit } from "@tiptap/starter-kit";
import { NWTabAdapter, NWTabsAdapter } from "@/wc/editor/components/nw-tabs/adapter.ts";
import { NWImageAdapter } from "@/wc/editor/components/nw-image/adapter.ts";
import { NWDividerAdapter } from "@/wc/components/base/nw-divider/adapter.ts";
import { NWVariableAdapter } from "@/wc/editor/components/nw-variable/adapter.ts";
import { NWCodeAdapter, NWCodeBlockAdapter } from "@/wc/editor/components/nw-code-block/adapter.ts";
import { ListItemAdapter } from "@/wc/editor/adapters/listItem.ts";
import { Mark } from "@tiptap/core";

export const NW_NOTE_CORE_EXTENSIONS = (placeholder?: string) => [
	StarterKit.configure({
		heading: false,
		blockquote: false,
		listItem: false,
		code: false,
		codeBlock: false,
	}),
	Placeholder.configure({ placeholder: placeholder ?? "Start typing your note..." }),
	NWTabsAdapter,
	NWTabAdapter,
	NWImageAdapter,
	NWDividerAdapter,
	NWVariableAdapter,
	NWCodeAdapter,
	NWCodeBlockAdapter,
	ListItemAdapter,
	HighlightDummy,
];

// We do not allow highlights in notes, but the code adapters still expect a mark named 'highlight' to exist.
const HighlightDummy = Mark.create({
	name: "highlight",
});
